import React from 'react';
import classNames from 'classnames';

import Icon from 'assets/icons';
import { AlertIcon, PlainButton } from 'components/shared';

import styles from './ConnectAppButton.module.scss';

interface ConnectAppButtonProps {
  isChecked: boolean;
  isError?: boolean;
  name: string;
  pending?: boolean;
  onClick: () => void;
}

const ConnectAppButton: React.FC<ConnectAppButtonProps> = ({
  children,
  isChecked,
  isError,
  name,
  pending,
  onClick,
  ...props
}) => {
  const classes = classNames({
    [styles.button]: true,
    [styles.disabled]: !onClick,
  });

  const isActive = isChecked ? styles.active : '';

  return (
    <PlainButton {...props} className={classNames(classes, isActive)} onClick={onClick}>
      {children}

      <div className={styles.checkbox}>
        {isChecked && <Icon.Checkmark className={styles.checkmark} />}
      </div>

      {pending && <div className={styles.status}>Coming Soon</div>}

      {isError && (
        <div className={styles.error}>
          <AlertIcon 
            className={styles.errorIcon}
            size="Medium"
          />
          <span className={styles.errorText}>Not Connected</span>
        </div>
      )}
    </PlainButton>
  );
};

export default ConnectAppButton;
